export class BarStorage {
    public static barMask: PIXI.Graphics;
    public static flare: PIXI.Sprite;
    public static flareX: number;
    public static barPersend: PIXI.Text;
    public static maxScore: number;
    public static maskOriginX: number; 
    public static barMain: PIXI.Container;
}